import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";

import localSlice from "@slices/local.slice";
import { RootState } from "@store/index";
import commonUtils from "@utils/common.utils";

export const usePwa = () => {
  const dispatch = useDispatch();
  const { showPWA } = useSelector((State: RootState) => State.local);

  const closePwaBanner = () => {
    dispatch(localSlice.actions.switchInstallPwaBanner(false));
  };
  const showPwaBanner = () => {
    dispatch(localSlice.actions.switchInstallPwaBanner(true));
  };

  const checkPwaInstalled = () => {
    window.addEventListener("appinstalled", () => {
      closePwaBanner();
      commonUtils.toastService(t("appInstalledSuccessfully"));
    });

    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      if (e) dispatch(localSlice.actions.checkPwaSupport(true));
      else dispatch(localSlice.actions.checkPwaSupport(false));
      if (showPWA) showPwaBanner();
    });

    if (window.matchMedia("(display-mode: standalone)").matches) {
      closePwaBanner();
    }
  };

  return { checkPwaInstalled, closePwaBanner, showPwaBanner };
};
